import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container } from '@mui/material';
import HeroSection from '../components/HeroSection';
import ValuesSection from '../components/ValuesSection';
import WhyChooseSection from '../components/WhyChooseSection';
import UseCases from '../components/UseCases';
import VisionSection from '../components/VisionSection';
import FinalCTA from '../components/FinalCTA';
import './About.css';

const About = () => {
  return (
    <>
      <Helmet>
        <title>Mission Sport | À propos</title>
        <meta 
          name="description" 
          content="Découvrez Mission Sport, la plateforme qui connecte les organisations sportives aux professionnels indépendants. Notre mission : faciliter la mise en relation et créer des opportunités dans le monde du sport."
        />
        <meta name="keywords" content="Mission Sport, sport, professionnels, organisations sportives, plateforme, mise en relation" />
        <meta property="og:title" content="Mission Sport | À propos" />
        <meta property="og:description" content="Connecter les talents, créer les opportunités dans le monde du sport" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="about-page">
        <HeroSection />
        
        <main>
          <section className="mission-section">
            <Container maxWidth="lg">
              <div className="mission-content">
                <h2>Notre Mission</h2>
                <p className="mission-text">
                  Mission Sport révolutionne la façon dont les organisations sportives 
                  et les professionnels indépendants se rencontrent. Notre plateforme 
                  facilite la mise en relation entre clubs, fédérations, associations 
                  et les talents du sport : entraîneurs, coachs, arbitres, préparateurs 
                  physiques et bien d'autres.
                </p>
                <p className="mission-text">
                  Nous créons un écosystème où chaque mission trouve son expert, 
                  où chaque professionnel découvre de nouvelles opportunités, 
                  et où le sport gagne en dynamisme et en professionnalisme.
                </p>
              </div>
            </Container>
          </section>

          <ValuesSection />
          <WhyChooseSection />
          <UseCases />
          <VisionSection />
        </main>

        <FinalCTA />
      </div>
    </>
  );
};

export default About;